<template>
    <div class="edit-pages-admin">
        <div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="title-button">
                            <h2>Editar páginas</h2>
                        </div>
                    </div>
                </div>

                <div class="edit-pages-panel">
                    <div class="content-items-form registration-flow-panel">
                        <div class="row">
                            <div class="col-12 col-md-4 padding-0">
                                <div class="left-content">
                                    <div>
                                        <h6 class="register">Editar páginas</h6>
                                        <div class="font-14 mb-70">Edite as páginas do site aqui.</div>

                                        <b-nav vertical>
                                            <b-nav-item
                                                :class="{ current: currentPage === 'EditPagesHomeForm' }"
                                                @click="changePage('EditPagesHomeForm')"
                                            >
                                                <!-- <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                            <i class="bi bi-border-all"></i> -->
                                                <!-- <img
                                                class="logo"
                                                :src="require(`@/assets/border-all.svg`)"
                                                alt="border-all"
                                            /> -->
                                                <div class="icon-item">
                                                    <IconsPP name="grid" />
                                                </div>

                                                Página inicial
                                            </b-nav-item>

                                            <b-nav-item>
                                                <div class="icon-item">
                                                    <IconsPP name="people" />
                                                </div>

                                                <b-nav-item-dropdown
                                                    id="my-nav-dropdown"
                                                    text="Sessões das páginas"
                                                    toggle-class="nav-link-custom"
                                                >
                                                    <b-dropdown-item
                                                        v-for="(session, index) in pageSessions"
                                                        :key="index"
                                                        @click="changePage('EditPagesSessionsForm')"
                                                    >
                                                        {{ session.name }}
                                                    </b-dropdown-item>
                                                </b-nav-item-dropdown>
                                            </b-nav-item>

                                            <b-nav-item
                                                :class="{ current: currentPage === 'EditPagesMenuForm' }"
                                                @click="changePage('EditPagesMenuForm')"
                                            >
                                                <div class="icon-item">
                                                    <svg
                                                        width="16"
                                                        height="18"
                                                        viewBox="0 0 16 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M3 16C2.449 16 2 15.551 2 15C2 14.449 2.449 14 3 14H14V16H3ZM3 2H14V12H3C2.647 12 2.314 12.072 2 12.184V3C2 2.449 2.449 2 3 2ZM15 0H3C1.346 0 0 1.346 0 3V15C0 16.654 1.346 18 3 18H14H15C15.552 18 16 17.552 16 17V16V14V1C16 0.448 15.552 0 15 0Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                </div>
                                                Menu
                                            </b-nav-item>

                                            <b-nav-item
                                                :class="{ current: currentPage === 'EditPagesSupportersForm' }"
                                                @click="changePage('EditPagesSupportersForm')"
                                            >
                                                <div class="icon-item">
                                                    <IconsPP name="people" />
                                                </div>
                                                Apoiadores
                                            </b-nav-item>

                                            <b-nav-item
                                                :class="{ current: currentPage === 'EditPagesFeedbacksForm' }"
                                                @click="changePage('EditPagesFeedbacksForm')"
                                            >
                                                <div class="icon-item">
                                                    <IconsPP name="email" />
                                                </div>
                                                Feedbacks
                                            </b-nav-item>
                                        </b-nav>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-8 padding-0">
                                <div class="right-content">
                                    <EditPagesHomeForm v-if="currentPage === 'EditPagesHomeForm'" />

                                    <EditPagesSessionsForm v-if="currentPage === 'EditPagesSessionsForm'" />

                                    <EditPagesMenuForm v-if="currentPage === 'EditPagesMenuForm'" />

                                    <EditPagesSupportersForm v-if="currentPage === 'EditPagesSupportersForm'" />

                                    <EditPagesFeedbacksForm v-if="currentPage === 'EditPagesFeedbacksForm'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="users-panel radius-6">
                    <div class="row head">
                        <div class="col-md-6">
                            <h6>Usuários da plataforma</h6>
                            <div class="font-14">Subtitulo aqui</div>
                        </div>

                        <div class="col-md-6 text-right buttons">
                            <b-button variant="dark" size="sm" class="icon-button display-inline-flex">
                                <b-icon icon="download" aria-hidden="true"></b-icon>
                                Exportar
                            </b-button>

                            <b-button
                                variant="primary"
                                size="sm"
                                v-b-toggle.sidebar-add-user
                                @click="openSidebarAddUser()"
                            >
                                Adicionar usuário
                            </b-button>
                        </div>
                    </div> -->

                <!-- <div class="filters display-flex">
                        <div class="filter-field">
                            <label for="search-field">Pesquisar</label>

                            <b-input-group class="search-field right-space">
                                <b-input-group-prepend>
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input placeholder="Pesquisar" v-model="searchFieldText"></b-form-input>
                            </b-input-group>
                        </div>

                        <b-form-group label="Perfil" label-for="profile" class="filter-field">
                            <b-form-select
                                id="profile"
                                name="profile"
                                v-model="profile.selected"
                                :options="profile.options"
                            ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Status" label-for="status" class="filter-field">
                            <b-form-select
                                id="status"
                                name="status"
                                v-model="status.selected"
                                :options="status.options"
                            ></b-form-select>
                        </b-form-group>
                    </div> -->

                <!-- </div> -->
            </div>
        </div>

        <!-- <b-modal
            ref="alter-profile-modal-ref"
            title="Trocar perfil"
            size="lg"
            cancel-title="Cancelar"
            ok-title="Alterar"
            ok-variant="primary"
            @ok="alterProfile"
            :ok-disabled="!alterProfilerForm.profile.selected"
            :modal-class="`alter-profile-modal ${getIsDarkTheme ? 'dark-theme' : ''}`"
        >
            <div class="content">
                <b-form-group label="Perfil" label-for="profile">
                    <b-form-select
                        name="profile"
                        v-model="alterProfilerForm.profile.selected"
                        :options="alterProfilerForm.profile.options"
                    ></b-form-select>
                </b-form-group>
            </div>
        </b-modal> -->
    </div>
</template>

<script>
import EditPagesHomeForm from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-home-form/EditPagesHomeForm'
import EditPagesSessionsForm from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-sessions-form/EditPagesSessionsForm'
import EditPagesMenuForm from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-menu-form/EditPagesMenuForm'
import EditPagesSupportersForm from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-supporters-form/EditPagesSupportersForm'
import EditPagesFeedbacksForm from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-feedbacks-form/EditPagesFeedbacksForm'
import IconsPP from '@/ui/icons-pp/IconsPP'

export default {
    components: {
        EditPagesHomeForm,
        EditPagesSessionsForm,
        EditPagesMenuForm,
        EditPagesSupportersForm,
        EditPagesFeedbacksForm,
        IconsPP
    },
    data() {
        return {
            // currentPage: 'EditPagesHomeForm',
            currentPage: 'EditPagesFeedbacksForm',
            pageSessions: [
                {
                    id: 1,
                    name: 'Home'
                },
                {
                    id: 2,
                    name: 'Quem somos'
                },
                {
                    id: 3,
                    name: 'De onde nascemos'
                }
            ]
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        changePage(page) {
            this.currentPage = page
        }
    }
}
</script>

<style scope src="./EditPagesAdmin-light-theme.css"></style>
<style scope src="./EditPagesAdmin-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/edit-pages-admin/EditPagesAdmin.vue